

function MainArea() {

    const width1 = 4
    const width2 = 5

    return (
    <> 
        <div className="row container">
            <h1 className={`col-md-7 greeting-welcome`}>.Hello</h1>
        </div>
        
        <div className="row container-fluid main-area">
            <div className={`col-md-${width1} photo-area1`}>
                <img src="https://dummyimage.com/500x500/f5f5f5/ba633d"/>         
            </div>
            <div className={`col-xl-${width2} text-area1`}>
                <p className="personal-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                Ut enim ad minim veniam, quis nostrud exercitation ullamco 
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
                reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
            </div>
        </div>
    </>
    )

}

export default MainArea
